<template>
    <section class="live-casino">
        <div class="container">
            <div class="main-tab-contant">
                <ul class="nav nav-pills">

                    <li class="nav-item" v-for="(item,index) in providerList" :key="index">
                        <button class="nav-btn" @click="clickOnSelectProvider(item)" :class="{active: selectedProvider?.id == item.id }">
                            <div class="nav-item-btn">
                                <figure>
                                    <img :src="item.image" alt="" loading="lazy" />
                                    <figcaption>
                                        {{ $t(item.slug, item.name) }}
                                    </figcaption>
                                </figure>
                            </div>
                        </button>
                    </li>

                </ul>
            </div>
        </div>
    </section>

    <section class="live-casino-tabs">
        <div class="container">
            <div class="mymarkett-main">
                <div class="mymarket-main" v-if="menuList != null && menuList.length != 0" >
                    <ul class="nav nav-tabs mart" id="myTaContent">

                        <li class="nav-item">
                            <button class="nav-link cmn-market" :class="{ 'active': selectedMenu == 'all' }"
                                role="tab" aria-controls="nav-sports" aria-selected="true" ria-current="page" @click="clickOnMenuItem('all')">
                                {{ $t('all', 'All') }}
                            </button>
                        </li>
                        <li class="nav-item" v-for="(item, itemKey) in menuList" :key="itemKey">
                            <button class="nav-link cmn-market" :class="{ 'active': selectedMenu.id == item.id }"
                                role="tab" aria-controls="nav-sports" aria-selected="true" ria-current="page" @click="clickOnMenuItem(item)">
                                {{ $t(item.slug, item.title) }}
                            </button>
                        </li>

                    </ul>
                </div>

                <div class="sport-main">
                    <div class="tab-content" id="myTaContent">

                        <div class="tab-pane show active" id="nav-sports" role="tabpanel" aria-labelledby="nav-sports">
                            <div class="multi-games live-casino-img">
                                <div class="container">
                                    <div class="multi-games-row">
                                        <div class="row g-2" v-if="filterGamesList != null && filterGamesList.length != 0">
                                            <GameItem :games="filterGamesList"></GameItem>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { mapGetters } from 'vuex';
export default {
    name: "Games",
    components: {
        GameItem: defineAsyncComponent(() =>
            import('@/shared/components/games/GameItem.vue')
        ),
    },
    data() {
        return {
            type: null,
            sectionsList: null,
            menuList: null,
            selectedMenu: null,
            providerList: null,
            selectedProvider: null,
            gameList: null
        }
    },
    computed: {
        filterGamesList() {
            let filteredGames = [];
            if(this.gameList) {
                return this.gameList;
            }
            if (this.menuList && this.selectedMenu) {
                if(this.selectedMenu == 'all') {
                    this.menuList.forEach(item => {
                        filteredGames.push(...item.games);
                    });
                } else {
                    filteredGames = this.menuList.find(m => m.id == this.selectedMenu.id);
                    filteredGames = filteredGames.games;
                }
            }
            const naturalCollator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
            filteredGames.sort((a, b) => naturalCollator.compare(a.porder, b.porder));
            return filteredGames;
        },
        ...mapGetters(['gamesData'])
    },
    mounted() {
        this.type = this.$route.params.type;
        if(this.$auth?.user?.actw == 'WB') {
            this.$router.push({name: 'Home'});
            return;
        };
        this.setGamesList();
    },
    methods: {
        clickOnSelectProvider(provider){
            this.selectedProvider = provider?.id
            if(!this.$auth.status) {
                this.$helper.showLogin();
                return;
            }
            this.$loadCasinoGame.loadGame(provider, this.$auth.user);
        },
        setGamesList() {
            if(this.gamesData?.[this.type]?.menus) {
                this.menuList = this.gamesData?.[this.type].menus;
                this.providerList = this.gamesData?.[`${this.type}-lobby`].games.sort((a, b) => a.porder - b.porder)
                this.selectedProvider = this.providerList[0];
                this.selectedMenu = 'all';
            } else {
                this.gameList = this.gamesData?.[this.type].games;
            }
        },
        clickOnMenuItem(item) {
            this.selectedMenu = item;
        },
        checkInEventMangeForGame(typeId, gameCode) {
            return this.$store.getters.eventManage ? this.$store.getters.eventManage?.filter(s => (s.type_id == typeId || s.type_id == gameCode)).length != 0 ? false : true : true;

        }
    }
};
</script>